// contexts/ModalContext.tsx
'use client'
import React, { createContext, useContext, useState, PropsWithChildren } from 'react'

type ModalContextValue = {
  showModal: boolean
  handleOpen: () => void
  handleClose: () => void
}

const ModalContext = createContext<ModalContextValue | null>(null)

export function ModalProvider({ children }: PropsWithChildren) {
  const [showModal, setShowModal] = useState(false)
  const handleOpen = () => setShowModal(true)
  const handleClose = () => setShowModal(false)

  const value: ModalContextValue = { showModal, handleOpen, handleClose }
  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
}

export function useModal(): ModalContextValue {
  const ctx = useContext(ModalContext)
  if (!ctx) throw new Error('useModal must be used within ModalProvider')
  return ctx
}
